
import { Component, Vue, Ref } from "vue-property-decorator";
import { taxRateRules } from "@common/src/utils/verify";
import { namespace } from "vuex-class";
const setting = namespace("setting");

@Component
export default class TaxRate extends Vue {
  @setting.Action salesTaxRateConfigurationSave;
  @setting.Action salesTaxRateConfigurationInfo;
  @Ref("taxFormRef") taxFormRef;
  // salesTaxRateModeDisAbled = true;
  form = {
    salesTaxRateMode: "EXTRA_TAX",
    salesTaxRateParam: {
      serviceTaxRate: 0,
      additionalFeesTaxRate: 0,
      partsTaxRate: 0
    }
  };
  formRules = {
    ["salesTaxRateParam.serviceTaxRate"]: {
      required: true,
      validator: this.validateRate,
      trigger: "blur"
    },
    ["salesTaxRateParam.additionalFeesTaxRate"]: {
      required: true,
      validator: this.validateRate,
      trigger: "blur"
    },
    ["salesTaxRateParam.partsTaxRate"]: {
      required: true,
      validator: this.validateRate,
      trigger: "blur"
    }
  };
  validateRate(rule, value, callback) {
    if (value === "") {
      callback(new Error(this.$t("base.please-input") as string));
    } else {
      const checkResult = taxRateRules(value, callback);
      if (!checkResult.success) {
        return callback(new Error(checkResult.msg));
      } else {
        callback();
      }
    }
  }
  async getRateInfo() {
    const { data = {} } = await this.salesTaxRateConfigurationInfo();
    this.form.salesTaxRateMode = data.salesTaxRateMode ?? "EXTRA_TAX";
    this.form.salesTaxRateParam.serviceTaxRate = data.salesTaxRateResult.serviceTaxRate ?? 0;
    this.form.salesTaxRateParam.additionalFeesTaxRate = data.salesTaxRateResult.additionalFeesTaxRate ?? 0;
    this.form.salesTaxRateParam.partsTaxRate = data.salesTaxRateResult.partsTaxRate ?? 6;
    // this.salesTaxRateModeDisAbled = data.salesTaxRateModeEnableEdit == 1 ? false : true; // 1可以修改 0不可以修改
  }
  async created() {
    await this.getRateInfo();
  }
  async submit() {
    this.salesTaxRateConfigurationSave(this.form).then(() => {
      this.$message.success(this.$t("base.save-success") as string);
      this.getRateInfo();
    });
  }
}
